<div class="app-shell" [class.app-shell--scroll]="shellPage">
  <header class="app-menubar border-b border-slate-200 bg-white px-2">
    <div class="mx-auto flex h-[38px] w-full items-center justify-between gap-4">
      <div class="flex min-w-0 items-center gap-4">
        <button
          type="button"
          class="app-menubar__brand"
          (click)="onTopNavSelect(nav[0])"
          [attr.title]="nav[0]?.text"
          >
          <img src="/assets/flow-studio-logo-32.png" alt="FlowStudio" class="h-6 w-6 rounded-md" />
          <span class="hidden truncate sm:inline">{{ nav[0]?.text }}</span>
        </button>

        <nav aria-label="Primary">
          <ul class="app-menubar__list">
            @for (item of topNavItems; track item) {
              <li class="app-menubar__list-item">
                <button
                  type="button"
                  class="app-menubar__link"
                  [class.app-menubar__link--accent]="item.cssClass === 'mcp-menu-item'"
                  (click)="onTopNavSelect(item)"
                  [attr.title]="item.text"
                  >
                  @if (item.internal == 'Learn') {
                    <fa-icon icon="user-graduate"></fa-icon>
                  }
                  @if (item.text == 'Subscriber') {
                    <i class="ms-Icon ms-Icon--ShoppingBagCheckmark" aria-hidden="true"></i>
                  }
                  @if (item.internal == 'Subscription' && item.text != 'Subscriber') {
                    <fa-icon icon="user-circle"></fa-icon>
                  }
                  @if (item.internal == 'Feedback') {
                    <i class="ms-Icon ms-Icon--ChatInviteFriend" aria-hidden="true"></i>
                  }
                  @if (item.internal == 'Services') {
                    <i class="ms-Icon ms-Icon--UserEvent" aria-hidden="true"></i>
                  }
                  @if (item.internal == 'MCP') {
                    <i class="ms-Icon ms-Icon--Rocket" aria-hidden="true"></i>
                  }
                  @if (item.text == 'Buy') {
                    <i class="ms-Icon ms-Icon--ShoppingBagAdd" aria-hidden="true"></i>
                  }
                  <span>{{ item.text }}</span>
                </button>
              </li>
            }
            @if (loggedIn && webinarActive) {
              <li class="app-menubar__list-item">
                <button
                  type="button"
                  class="app-menubar__link app-menubar__link--webinar"
                  title="Live webinar — Flow Studio MCP Server, Monday 17 August"
                  (click)="showWebinar()"
                  >
                  <i class="ms-Icon ms-Icon--Streaming" aria-hidden="true"></i>
                  <span>Webinar</span>
                </button>
              </li>
            }
          </ul>
        </nav>
      </div>

      <div class="app-menubar__actions flex items-center gap-2">
        @if ((this.hasUpdate$ | async)) {
          <div
            class="hidden items-center gap-1.5 rounded border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs text-amber-900 lg:flex"
            >
            <i class="ms-Icon ms-Icon--InstallToDrive" aria-hidden="true"></i>
            <span>Version Updating...</span>
          </div>
        }

        @if (this.reauthPrompt$ | async; as reauthPrompt) {
          <button
            type="button"
            class="app-menubar__reauth-trigger"
            [attr.title]="reauthPrompt.message"
            (click)="onReauthBannerAction()"
            >
            <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true"></i>
            <span>{{ reauthPrompt.actionLabel }}</span>
          </button>
        }

        @if (loggedIn) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors"
            title="What's New"
            (click)="showWhatsNew()"
            >
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"/></svg>
            <span>What's New</span>
          </button>
        }

        @if (loggedIn) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors"
            title="Send bug report"
            [disabled]="isFeedbackDialogOpen"
            (click)="showFeedback(null, 'bug')"
            >
            <i class="ms-Icon ms-Icon--Bug" aria-hidden="true"></i>
            <span>Bug Report</span>
          </button>
        }

        @if (loggedIn && this.isApp() && ((scanLoading$ | async) || environment)) {
          @if ({ loading: (scanLoading$ | async), age: (scanAge$ | async), progress: (scanProgress$ | async) }; as scanState) {
            <div class="app-refresh-split">
              <button
                type="button"
                class="app-refresh-split__main"
                [class.app-refresh-split__main--active]="scanState.loading"
                [class.app-refresh-split__main--stale]="!scanState.loading && scanState.age?.stale"
                [title]="scanState.loading ? 'Cancel current refresh' : (scanState.age?.label ? ('Cached ' + scanState.age.label + ' - click to refresh') : 'Refresh now')"
                (click)="onScanPrimaryClick(!!scanState.loading)"
                >
                @if (scanState.loading) {
                  <i class="ms-Icon ms-Icon--Cancel" aria-hidden="true"></i>
                  <span>Loading (Cancel)</span>
                } @else {
                  <i class="ms-Icon ms-Icon--Refresh" aria-hidden="true"></i>
                  @if (scanState.age; as ageInfo) {
                    <span>Refreshed {{ ageInfo.label }}</span>
                  } @else {
                    <span>Refresh</span>
                  }
                }
              </button>
              <button
                type="button"
                class="app-refresh-split__arrow"
                [class.app-refresh-split__arrow--active]="refreshProgressOpen"
                title="Refresh activity"
                cdkOverlayOrigin
                #refreshProgressOrigin="cdkOverlayOrigin"
                (click)="toggleRefreshProgress()"
                >
                <span class="app-menubar__summary-caret" [class.app-menubar__summary-caret--open]="refreshProgressOpen" aria-hidden="true"></span>
              </button>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="refreshProgressOrigin"
                [cdkConnectedOverlayOpen]="refreshProgressOpen"
                [cdkConnectedOverlayHasBackdrop]="true"
                cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                [cdkConnectedOverlayPositions]="dropdownPositionsRight"
                [cdkConnectedOverlayOffsetY]="4"
                (backdropClick)="closeMenus()"
                (detach)="closeMenus()"
                >
                <div class="app-refresh-panel">
                  <div class="app-refresh-panel__header">
                    <span>Refresh Activity</span>
                    @if (scanState.loading) {
                      <span class="app-refresh-panel__pill">Running</span>
                    }
                  </div>
                  @if (scanState.progress?.length) {
                    <div class="app-refresh-panel__items">
                      @for (item of scanState.progress; track item.id) {
                        <div class="app-refresh-panel__item" [class.app-refresh-panel__item--running]="item.status === 'running'">
                          <span class="app-refresh-panel__dot" [class.app-refresh-panel__dot--done]="item.status === 'done'" [class.app-refresh-panel__dot--failed]="item.status === 'failed'" [class.app-refresh-panel__dot--cancelled]="item.status === 'cancelled'"></span>
                          <div class="app-refresh-panel__item-body">
                            <span class="app-refresh-panel__item-label">{{ item.label }}</span>
                            @if (item.completed != null || item.total != null) {
                              <span class="app-refresh-panel__item-count">
                                {{ item.completed ?? 0 }}@if (item.total != null) { <span>/ {{ item.total }}</span> }
                              </span>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="app-refresh-panel__empty">No refresh activity yet.</div>
                  }
                </div>
              </ng-template>
            </div>
          }
        }


        @if (this.isApp() && loggedIn) {
          <div class="hidden sm:block">
            <button
              type="button"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors min-w-[52px] max-w-[200px]"
              cdkOverlayOrigin
              #envOrigin="cdkOverlayOrigin"
              (click)="toggleMenu('environment')"
              >
              <i class="ms-Icon ms-Icon--MapLayers flex-none" aria-hidden="true"></i>
              <span class="min-w-0 flex-1 truncate">{{ environmentLabel }}</span>
              <span class="app-menubar__summary-caret flex-none" [class.app-menubar__summary-caret--open]="environmentMenuOpen" aria-hidden="true"></span>
            </button>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="envOrigin"
              [cdkConnectedOverlayOpen]="environmentMenuOpen"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              [cdkConnectedOverlayPositions]="dropdownPositionsLeft"
              [cdkConnectedOverlayOffsetY]="4"
              (backdropClick)="closeMenus()"
              (detach)="closeMenus()"
              >
              <div class="app-menubar__dropdown-panel">
                @for (item of environmentOptions; track item) {
                  <button
                    type="button"
                    class="app-menubar__dropdown-item"
                    [class.app-menubar__dropdown-item--active]="item.environment === environment"
                    (click)="onEnvironmentAction(item)"
                    >
                    <i class="ms-Icon ms-Icon--MapLayers" aria-hidden="true"></i>
                    <span class="truncate">{{ item.text }}</span>
                  </button>
                }
              </div>
            </ng-template>
          </div>
        }

        @if (loggedIn) {
          <div>
            <button
              type="button"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors min-w-[52px]"
              cdkOverlayOrigin
              #userOrigin="cdkOverlayOrigin"
              (click)="toggleMenu('user')"
              >
              <i class="ms-Icon ms-Icon--IDBadge flex-none" aria-hidden="true"></i>
              <span class="hidden max-w-[180px] truncate sm:inline">{{ menu[0]?.text }}</span>
              <span class="app-menubar__summary-caret flex-none" [class.app-menubar__summary-caret--open]="userMenuOpen" aria-hidden="true"></span>
            </button>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="userOrigin"
              [cdkConnectedOverlayOpen]="userMenuOpen"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              [cdkConnectedOverlayPositions]="dropdownPositionsRight"
              [cdkConnectedOverlayOffsetY]="4"
              (backdropClick)="closeMenus()"
              (detach)="closeMenus()"
              >
              <div class="app-menubar__dropdown-panel">
                @for (item of userMenuOptions; track item) {
                  <button
                    type="button"
                    class="app-menubar__dropdown-item"
                    (click)="onUserAction(item)"
                    >
                    @if (item.ms_icon) {
                      <i class="ms-Icon" [ngClass]="'ms-Icon--' + item.ms_icon" aria-hidden="true"></i>
                    }
                    <span>{{ item.text }}</span>
                  </button>
                }
              </div>
            </ng-template>
          </div>
        }


      </div>
    </div>


  </header>

  <ng-template #templateNotification>
    <div style="width: 600px;">
      FlowStudio has disconnected from Power Automate, hit <a href='#' (click)="refresh()" style="cursor: pointer; color: black;" >refresh</a> to reconnect.<br>
      <span style="word-break: break-all;">
        {{error}}
      </span>

    </div>
  </ng-template>
  <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>
  @if (!isIframe) {
    <router-outlet name="primary" data-outlet-scope="app-root"></router-outlet>
  }

  @if (this.reauthPromptModal$ | async) {
    <div class="app-reauth-modal__overlay"></div>
  }
  @if (this.reauthPromptModal$ | async; as reauthPrompt) {
    <section class="app-reauth-modal" role="dialog" aria-modal="true" aria-labelledby="app-reauth-title">
      <h3 id="app-reauth-title">Re-Authentication Required</h3>
      <p>
        {{ reauthPrompt.message || 'FlowStudio needs you to sign in again to refresh your permissions.' }}
        Continue to Microsoft sign-in to keep using FlowStudio.
      </p>
      <div class="app-reauth-modal__actions">
        <button type="button" class="app-reauth-modal__btn app-reauth-modal__btn--primary" (click)="this.continueReauthFromModal()">Continue Re-Authentication</button>
      </div>
    </section>
  }
</div>
